import { supabase } from "../../supabaseClient"


export const sendEmail = (to, subject, content) => {
    supabase.functions.invoke("emailSend", {
        body: JSON.stringify({ to, subject, html: content })
    })
}